String.prototype.replaceAll = function(s1: any, s2: any) {
  return this.replace(new RegExp(s1, 'gm'), s2);
};

export class DataUtil {

  public static replaceConfig(str: string, config: TemplateInterface): string{
    str = str.replaceAll(`{{productName}}`, config.productName || '')
             .replaceAll(`{{companyFullName}}`, config.companyFullName || '')
             .replaceAll(`{{companyShortName}}`, config.companyShortName || '')
             .replaceAll(`{{officialWebsite}}`, config.officialWebsite || '')
             .replaceAll(`{{practicalCompanyName}}`, config.practicalCompanyName || '')
             .replaceAll(`{{IcpNumber}}`, config.IcpNumber || '')
             .replaceAll(`{{sdkWebsite}}`, config.sdkWebsite || '')
             .replaceAll(`{{apprentice}}`, config.apprentice || '')
             .replaceAll(`{{anapprentice}}`, config.anapprentice || '')
             .replaceAll(`{{mail}}`, config.mail || '')
             .replaceAll(`{{cashConfig}}`, config.cashConfig || '');
             
    return str;
  }
}
